export default __webpack_public_path__ + "static/media/blog-home-image_mobile.282f0714.webp";